module.exports = __webpack_public_path__ + "img/jumbo-unsplash.e2d6c909.png";